import type { PlatformName } from '../api/types.js';

/**
 * Platforms Connaro advertises on its unauthenticated pages (§18).
 *
 * ONE list, because this claim appears where nobody signed in can check it and
 * nothing corrects it. §18 forbids claiming support that has not been
 * validated, and a sign-in page showing eight logos while five work is exactly
 * that claim — made to the people least able to verify it.
 *
 * `tests/console-help-accuracy.integration.test.ts` asserts every entry here
 * against the server's own catalog, so a platform cannot be advertised before
 * it is implemented, and one that becomes implemented is noticed.
 */
export const ADVERTISED_PLATFORMS: { platform: PlatformName; displayName: string }[] = [
  { platform: 'twitch', displayName: 'Twitch' },
  { platform: 'youtube', displayName: 'YouTube' },
  { platform: 'kick', displayName: 'Kick' },
  { platform: 'blaze', displayName: 'Blaze' },
  { platform: 'discord', displayName: 'Discord' },
];
